import gsap from "gsap";

export default class mobileMenu {

    opened = false;
    animationPlayed = false;

    constructor() {
        this.btn = document.querySelector(".js-menu-btn");

        if(!this.btn) {
            return;
        }  
        
        this.block = document.querySelector(".js-mobile-menu");
        
        this.menuItems = this.block.querySelectorAll(".hns-mm__item");
        this.socialBlock = document.querySelector(".st-header");

        this.btn.addEventListener("click", () => {
            if(this.animationPlayed) {
                return;
            }

            this.animationPlayed = true;

            if(this.opened) {
                this.close();
            } else {
                this.show();
            }
        });


    }

    show() {
        this.scrollPosition = window.scrollY;
        document.body.classList.add('hns-overview-mode__menu');
        //this.block.classList.add('hns-mm__view');

        this.opened = true;

        // Анимация кнопки
        gsap.to(this.btn.querySelector('svg:first-of-type'), {
            opacity:0
        })
        gsap.to(this.btn.querySelector('svg:last-of-type'), {
            opacity:1
        })

        let left = window.innerWidth - this.socialBlock.getBoundingClientRect().x;

        console.log(left);

        // Анимация блока
        gsap.to(this.block, {
            x: left * -1,
            duration:0.8,
            ease: "sine.inOut",
        });

        // Анимация пунктов меню
        let delay = 0.06;
        let i = 0;
        for(let item of this.menuItems) {
            gsap.fromTo(
                item, 
                {
                    x: "100%",
                }, {
                    x: "0%",
                    duration:0.6,
                    delay: delay * i++, 
                    ease: "sine.inOut"
                }
            );
        }

        setTimeout(()=>{
            this.animationPlayed = false;
        }, 1000)

    }

    close() {
        document.body.classList.remove('hns-overview-mode__menu');
        //this.block.classList.remove('hns-mm__view');
        window.scroll(0, this.scrollPosition);
        
        this.opened = false;

        // Анимация кнопки
        gsap.to(this.btn.querySelector('svg:first-of-type'), {
            opacity:1
        })
        gsap.to(this.btn.querySelector('svg:last-of-type'), {
            opacity:0
        })

        // Анимация блока
        gsap.to(this.block, {
            x: "0%",
            duration: 0.8,
            ease: "sine.inOut",
        });

        // Анимация пунктов меню
        let delay = 0.06;
        let i = 0;
        for(let item of this.menuItems) {
            gsap.fromTo(
                item, 
                {
                    x: "0%",
                }, {
                    x: "100%",
                    duration:0.8,
                    delay: delay * i++, 
                    ease: "sine.inOut",
                }
            );
        }

        setTimeout(()=>{
            this.animationPlayed = false;
        }, 1000) 

    }

    isOpen() {
        return  this.opened;
    }
}